var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-component": "base-content-loader" } }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _vm.title
          ? _c("div", { staticClass: "title" }, [
              _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.$slots.actions
          ? _c("or-loader", { attrs: { variant: _vm.variant } })
          : _vm._e(),
        _vm._v(" "),
        _vm.description
          ? _c("div", { staticClass: "description" }, [
              _vm._v("\n      " + _vm._s(_vm.description) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("actions"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }